/**
 * This file is part of OXID eSales Flow theme.
 *
 * OXID eSales Flow theme is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * OXID eSales Flow theme is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with OXID eSales Flow theme.  If not, see <http://www.gnu.org/licenses/>.
 *
 * @link      http://www.oxid-esales.com
 * @copyright (C) OXID eSales AG 2003-2016
 */

function initYotpoLinks() {
    const mutationObserverConfig = { attributes: false, childList: true, subtree: true };

    // pdp - correct inner link, next to the review stars -> jump to review tab now works
    const gotoReviewLink = document.querySelector("a#goto-review");
    const gotoReviewObserver = new MutationObserver(() => {
        const yotpoLink = gotoReviewLink.querySelector("a");
        const linkHref = gotoReviewLink.getAttribute("href");
        yotpoLink?.setAttribute("href", linkHref);
        yotpoLink?.setAttribute("aria-label", yotpoLink?.textContent);
    });
    if (gotoReviewLink) {
        gotoReviewObserver.observe(gotoReviewLink, mutationObserverConfig);
    }

    // pdp - correct productlink "not crawlable"
    const ratingsBox = document.querySelector("#ratings");
    const reviewContainerObserver = new MutationObserver(() => {
        const links = ratingsBox.querySelectorAll('a.product-link-wrapper');
        links.forEach(link => {
            if (!link.getAttribute("href")) {
                link.setAttribute("href", "#");
            }
        });
    });
    if (ratingsBox) {
        reviewContainerObserver.observe(ratingsBox, mutationObserverConfig);
    }

    // pop - correct star link "not crawlable"
    const ratingElements = document.querySelectorAll(".listitem-rating");
    ratingElements.forEach((rating) => {
        const observer = new MutationObserver(() => {
            const link = rating.querySelector("a");
            link?.setAttribute("href", "#");
        });
        observer.observe(rating, mutationObserverConfig);
    });
}

$(document).ready(function () {
    var $oReviewRating = $('#reviewRating');

    initYotpoLinks();

    if ($oReviewRating.length) {
        var $oRatingForm = $('#rating');

        $oReviewRating.find('.ox-write-review').on('click mouseenter touch', function () {
            var $this = $(this),
                $oParent = $this.parent();

            $oParent.prevAll().find('i').removeClass('fa-star-o').addClass('fa-star');
            $oParent.nextAll().find('i').removeClass('fa-star').addClass('fa-star-o');
            $this.find('i').removeClass('fa-star-o').addClass('fa-star');

            $oRatingForm.find('#recommListRating, #productRating').val($oParent.attr('data-rate-value'));
        });
    }
});
